import { Platform, useColorScheme } from 'react-native';
import { useTheme } from '../theme';

/**
 * Android force-dark can invert the native Picker dropdown background while
 * leaving item text dark. Use these colors on every Picker.Item `color` prop.
 */
export function usePickerItemColor() {
  const { theme } = useTheme();
  const colorScheme = useColorScheme();
  const isAndroidDark = Platform.OS === 'android' && colorScheme === 'dark';

  return {
    pickerItemColor: isAndroidDark ? '#FFFFFF' : theme.colors.text,
    pickerItemColorSecondary: isAndroidDark
      ? '#FFFFFF'
      : theme.colors.textSecondary,
    pickerItemColorTertiary: isAndroidDark
      ? '#FFFFFF'
      : theme.colors.textTertiary,
  };
}
